export const cleanUpSweepTimeResponse = (
  analyzerInput: string | undefined | null,
  analyzerType: 0 | 1 | 3 | 4 | undefined
) => {
  if (!analyzerInput || analyzerType === undefined) return '';
  if (analyzerType !== 1) return analyzerInput;
  // Remove units and nonprintable characters from 3000R input
  return analyzerInput.replace(/[^ -~]+/g, '');
};
